<template>
  <div class="container">
    <div class='image-editor'>
      <div class="panels">
        <Panel
          v-for="panel in panels"
          :key="panel.id"
          :panel="panel"
        />
      </div>
      <Result/>
    </div>
  </div>
</template>

<script>
import editorController from '../controllers/editor';
import Panel from '../components/Panel.vue';
import Result from '../components/Result.vue';

export default {
  name: 'ImageEditor',
  components: {
    Result,
    Panel,
  },
  computed: {
    panels() {
      return this.$store.getters.panels;
    },
  },
  methods: {
    addPanel(panelOptions) {
      this.$store.dispatch('addPanel', panelOptions);
    },
  },
  mounted() {
    // eslint-disable-next-line consistent-return
    window.onbeforeunload = () => {
      if (this.$store.getters.isDirty) {
        return 'Are you sure you want to leave? '
          + 'You will lose all of your changes.';
      }
    };

    editorController.init();
    const { defaultPanelCount } = this.$store.getters;
    const zooms = [1, 2, 4];
    for (let i = 0; i < defaultPanelCount; i += 1) {
      this.addPanel({
        zoom: zooms[i],
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isDirty) {
      // eslint-disable-next-line no-alert
      const answer = window.confirm('Are you sure you want to leave? '
        + 'You will lose all of your changes.');
      if (answer) {
        next();
      }
      else {
        next(false);
      }
    }
    else {
      next();
    }
  },
};
</script>

<style scoped lang="scss">
  .image-editor {
    display: flex;
    justify-content: space-between;
    height: calc(100% - 30px);
    min-height: calc(100% - 30px);
  }

  .panels {
    flex-grow: 1;
  }
</style>
